/* eslint-disable */
// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

const initialUser = () => {
  const userData = localStorage.getItem("userData");
  return userData ? JSON.parse(userData) : {};
};

const initialToken = localStorage.getItem("token") || null;
const initialRefreshToken = localStorage.getItem("refreshToken") || null;

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    user: initialUser(),
    token: initialToken,
    refreshToken: initialRefreshToken,
    notiCount: 0,

  },
  reducers: {
    handleLogin: (state, action) => {
      const { data, access_token, refresh_token } = action.payload;
      state.user = data;
      state.token = access_token;
      state.refreshToken = refresh_token;
      localStorage.setItem("userData", JSON.stringify(data));
    },
   addNotiCount: (state, action) => {
      state.notiCount = action.payload;
    },
    handleLogout: (state) => {
      state.user = {};
      state.token = null;
      state.refreshToken = null;
      localStorage.removeItem("userData");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
  },
});

export const { handleLogin, handleLogout, addNotiCount } = authSlice.actions;

export default authSlice.reducer;
